var _clipPath, _use, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinDotSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "dotsClip"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "dots",
    fill: "#F5FB6B",
    cx: 16,
    cy: 16,
    r: 16
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    clipPath: "url(#dotsClip)",
    xlinkHref: "#dots"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "pin-dot-small-wb-a",
    cx: 16,
    cy: 16,
    r: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("mask", {
    id: "pin-dot-small-wb-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pin-dot-small-wb-a"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "#F5FB6B",
    fillRule: "nonzero",
    stroke: "#00DFE6",
    mask: "url(#pin-dot-small-wb-b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06F3F9",
    fillRule: "nonzero",
    d: "M9.157,22.607 C5.435,22.607 2.157,20.367 0.807,16.899 C0.565,16.277 0.873,15.578 1.494,15.336 C2.114,15.094 2.814,15.401 3.057,16.023 C4.043,18.556 6.437,20.193 9.157,20.193 C11.877,20.193 14.271,18.556 15.257,16.023 C15.499,15.402 16.199,15.094 16.82,15.336 C17.441,15.578 17.749,16.278 17.507,16.899 C16.157,20.367 12.879,22.607 9.157,22.607 M13.655,7.945 C12.761,7.945 12.033,8.672 12.033,9.566 C12.033,10.461 12.761,11.188 13.655,11.188 C14.549,11.188 15.277,10.461 15.277,9.566 C15.277,8.672 14.549,7.945 13.655,7.945 M13.655,13.489 C11.492,13.489 9.733,11.729 9.733,9.566 C9.733,7.404 11.493,5.644 13.655,5.644 C15.818,5.644 17.578,7.404 17.578,9.566 C17.578,11.729 15.818,13.489 13.655,13.489 M4.663,5.934 L4.663,7.787 C4.663,7.874 4.733,7.944 4.82,7.944 L6.244,7.944 L6.244,9.473 C6.244,10.345 5.53,11.078 4.658,11.063 C3.81,11.049 3.126,10.355 3.126,9.503 L3.126,4.016 C3.126,3.148 3.836,2.416 4.704,2.426 C5.5,2.436 6.154,3.046 6.235,3.822 C6.243,3.903 6.309,3.965 6.39,3.965 L8.507,3.965 C8.597,3.965 8.669,3.89 8.665,3.801 C8.567,1.673 6.795,-0.024 4.638,-8.8817842e-16 C2.448,0.025 0.7,1.844 0.7,4.035 L0.7,9.453 C0.7,11.647 2.452,13.467 4.645,13.488 C6.861,13.51 8.669,11.714 8.669,9.504 L8.669,7.944 L8.672,7.944 L8.672,5.855 C8.672,5.812 8.637,5.776 8.594,5.776 L4.82,5.776 C4.734,5.776 4.663,5.846 4.663,5.934",
    transform: "translate(7 5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinDotSmall);
export default __webpack_public_path__ + "static/media/pin-dot-small.c6f5a2c3a17573475a781a53303d42f6.svg";
export { ForwardRef as ReactComponent };